export default "__VITE_ASSET__IrToNRWU__"